export default "__VITE_ASSET__0fbbd64f__"